'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/map/Map.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var MapIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  __spreadProps(__spreadValues({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ jsx("path", { d: "M2 5.52946L8 3.52946V18.6376L2 20.6376V5.52946Z", fill: "currentColor" }),
      /* @__PURE__ */ jsx("path", { d: "M14 19.971L10 18.6376V3.52946L14 4.86279V19.971Z", fill: "currentColor" }),
      /* @__PURE__ */ jsx("path", { d: "M16 19.971L22 17.971V2.86279L16 4.86279V19.971Z", fill: "currentColor" })
    ]
  })
);

// src/map/MapOutlined.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var MapOutlinedIcon = (props) => /* @__PURE__ */ jsx2(
  "svg",
  __spreadProps(__spreadValues({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx2(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22 3.11279V18.221L15 20.5543L9 18.5543L2 20.8876V5.77946L9 3.44613L15 5.44613L22 3.11279ZM14 7.22098L10 5.88764V16.7795L14 18.1128V7.22098ZM16 18.1128L20 16.7795V5.88764L16 7.22098V18.1128ZM8 16.7795V5.88764L4 7.22098V18.1128L8 16.7795Z",
        fill: "currentColor"
      }
    )
  })
);

export {
  MapIcon,
  MapOutlinedIcon
};
//# sourceMappingURL=chunk-FKK4HJWE.mjs.map